export const RESOURCE_USER_TYPE = {
  UNASSIGNED: 'UNASSIGNED',
  ASSIGNED: 'ASSIGNED',
  TOBEHIRED: 'TOBEHIRED'
};
